import React from 'react'
import { Link } from 'react-router-dom'

const Cards = () => {
    return (
        <>
            <div className='relative flex flex-col justify-center items-center w-full '>
                <div className='relative'>
                    <div className="md:mt-12 m-3">
                        <h2 className="md:text-2xl text-center text-xl font-bold">
                            Using AS-Tech Community You Can Increase Connections
                        </h2>
                        <div className="border-t-4 border-orange-500 mt-2 w-10 mx-auto rounded-full"></div>
                    </div>
                    <div className='absolute md:-right-[40%] right-6'>
                        <img src={require('../assets/images/dotsimage.png')} alt="" className='w-24 h-24' />
                    </div>
                </div>
                {/* <h2 className='md:text-2xl text-xl font-bold px-6 text-center'>Using AS Tech Community You Can</h2> */}


                <div className='flex justify-center items-center'>
                    <div className='left-[-250px] absolute bg-gradient-to-r from-black to-logo rounded-3xl z-[1000] top-20 md:top-28 md:w-[480px] w-[280px] md:h-[480px] h-[280px] rotate-45'>
                        <div className='relative'>
                            <img src={require('../assets/images/Gifts/new mobile.png')} className='absolute md:left-60 left-44 lg:w-[80%] md:w-[60%] w-[70%] -top-32 md:-top-36 -rotate-45' alt="" />
                        </div>
                        <div className='relative'>
                            <img src={require('../assets/images/line 2-01.png')} className='absolute  left-28 lg:w-[100%] md:w-[60%] w-[70%] -top-32 md:top- h-[420px] -z-50  -rotate-45' alt="" />
                        </div>
                    </div>
                    <div className='flex flex-col justify-center xl:pl-[480px] md:pl-80  md:mt-20 md:mr-24 mt-60 px-6 md:w-[75%] xl:w-[100%]'>
                        {/* <h2 className='font-bold'>Speed</h2> */}
                        <div className="mb-3">
                            <h2 className='md:text-2xl text-xl font-bold text-logo'>
                                OUR SHINING WHATSAPP GROUP
                            </h2>
                            <div className="border-t-4 border-orange-500 mt-1 w-10 rounded-full"></div>
                        </div>

                        <p className=''>
                            <span className='font-bold'>
                                Connect with like-minded tech enthusiasts in our vibrant <Link to='https://chat.whatsapp.com/Ly9eCbbsdtkGeL9pOoQKg1' className='text-logo underline'>WhatsApp Group</Link>, where collaboration and knowledge sharing thrive.
                            </span>
                            <br />
                            <span className='font-bold text-logo'>Here, you'll:</span>
                            <br />
                            ✓ Stay updated on latest announcements and industry news<br />
                            ✓ Learn from peers and senior tech mentors<br />
                            ✓ Discuss trending topics and innovative ideas<br />
                            ✓ Discover new opportunities and resources<br />
                            ✓ Receive support and guidance from experienced professionals<br />

                            <span className='font-bold'> AS-Tech Whatsapp Group offers a welcoming space to:</span><br />

                            ✓ Share your thoughts and expertise<br />
                            ✓ Seek help and feedback from fellow members<br />
                            ✓ Expand your network and build meaningful connections<br />

                            <span className='font-bold'>Be part of AS-Tech Community today and elevate your tech journey!"</span>
                        </p>
                    </div>
                </div>

            </div>

            <div className='relative flex flex-col md:justify-start md:items-start justify-center items-center w-full overflow-hidden'>
                {/* <h2 className='md:text-2xl text-xl font-bold'>Using AS Tech Community You Can</h2> */}


                <div className='flex justify-center items-center'>
                    <div className=' right-[-250px] absolute bg-gradient-to-r from-black to-logo rounded-3xl z-[1000] md:top-40 top-12 md:w-[480px] w-[280px] md:h-[480px] h-[280px] rotate-45'>
                        <div className='relative'>
                            <img src={require('../assets/images/mobile final-01.png')} className='absolute right-40 top-48 lg:w-[100%] md:w-[60%] w-[70%] -rotate-45' alt="" />
                        </div>
                        <div className='relative'>
                            <img src={require('../assets/images/line 3-01.png')} className='absolute right-0 top-8 -z-50 lg:w-[100%] md:w-[60%] w-[70%] -rotate-45' alt="" />
                        </div>
                    </div>
                    <div className='flex flex-col justify-center lg:mr-80 md:mr-80 md:mt-40 mt-96 lg:w- md:w-[55%] px-6'>
                        {/* <h2 className='font-bold'>Speed</h2> */}
                        <div className="mb-3">
                            <h2 className='md:text-2xl text-xl font-bold text-logo'>
                                OUR FOUR PROGRAMS
                            </h2>
                            <div className="border-t-4 border-orange-500 mt-1 w-10 rounded-full"></div>
                        </div>

                        <div className=''>
                            <h2>
                                <span className='font-bold'>1. Talent Hiring Program:                                :</span>
                                <br />Find and hire top freelancers in the tech field. Whether you're looking for project-bbased hiring or permanent job, we have a wide range of developers, designers, sales experts, marketers, and other roles.<br />
                            </h2>
                            <button className='my-3'>
                                <Link to='/tech-talent-program' className="text-sm bg-gradient-to-r text-md  from-orange-500 to-red-500 text-white py-2 px-3 rounded-full font-semibold shadow-lg">
                                    View More
                                </Link>
                            </button>
                            <h2>
                                <span className='font-bold'>2. Business Development Program:</span> <br /> Directly submit your requirements to us, whether it's a temporary project or a long-term business. Our team of expert business developers will analyze your needs and provide a tailored solution. Our dedicated staff will handle your project at the client  portal.
                            </h2>
                            {/* <br /> */}
                            {/* Click (View More)  Lead to Services Page */}
                            <button className='my-3'>
                                <Link to='/' className="text-sm  bg-gradient-to-r from-orange-500 to-red-500 text-md  text-white py-2 px-3 rounded-full font-semibold shadow-lg">
                                    View More
                                </Link>
                            </button>
                            {/* <br /> */}
                            <h2 className='my-'>
                                <span className='font-bold'>3. Skills Learning Program:</span> <br />This program is launched to provide courses to unskilled people who are in need of quick learning. We aim to make them able to earn by learning relevant skills. We are launching live courses, education, and guides for newbies.
                            </h2>
                            {/* <br /> */}
                            <button className='my-3'>
                                <Link to='/digital-skills-program' className="text-sm  bg-gradient-to-r text-md  from-orange-500 to-red-500 text-white py-2 px-3 rounded-full font-semibold shadow-lg">
                                    View More
                                </Link>
                            </button>
                            {/* <br /> */}
                            <h2 className='my-'>
                                <span className='font-bold'> 4. Charity Program:</span> <br />This program aims to support people in need. It relies on funds deposited by community members, which are used to uplift financially deprived members. We also hear and submit stories of people to highlight important issues for their welfare.
                            </h2>

                            {/* <br /> */}
                            <button className='my-3'>
                                <Link to='/charity-program' className="text-sm my- bg-gradient-to-r from-orange-500 to-red-500  text-md  text-white py-2 px-3 rounded-full font-semibold shadow-lg">
                                    View More
                                </Link>
                            </button>

                        </div>
                    </div>
                </div>

                <div className='md:left-0'>
                    <img src={require('../assets/images/trianglelines.png')} className='w-28' />
                </div>

            </div>

            <div className='relative flex flex-col justify-center items-center w-full '>
                {/* <h2 className='md:text-2xl text-xl font-bold'>Using AS Tech Community You Can</h2> */}


                <div className='flex justify-center items-center'>
                    <div className='left-[-250px] absolute bg-gradient-to-r from-black to-logo rounded-3xl z-[1000] md:top-10 top-10 md:w-[480px] w-[280px] md:h-[480px] h-[280px] rotate-45'>
                        <div className='relative'>
                            <img src={require('../assets/images/mission final-01.png')} className='lg:w-[100%] md:w-[70%] w-[80%] absolute md:left-60 left-40 -top-40 md:-top-60 -rotate-45' alt="" />
                        </div>
                        <div className='relative'>
                            <img src={require('../assets/images/line 2-01.png')} className='absolute  left-40 lg:w-[100%] md:w-[60%] w-[70%] -top-32 md:top- h-[420px] -z-50  -rotate-45' alt="" />
                        </div>
                    </div>
                    <div className='flex flex-col justify-center lg:pl-[150px] lg:ml-80 md:ml-96 md:mt-40 mt-80 px-6 md:pr-24'>
                        <div className="mb-3">
                            <h2 className='md:text-2xl text-xl font-bold text-logo '>
                                OUR VISION & METHODOLOGY.
                            </h2>
                            <div className="border-t-4 border-orange-500 mt-2 w-10 rounded-full"></div>
                        </div>

                        <p className='text-'>AS-Tech Community aims to create a friendly platform for users who find all Tech Solutions & Services through a single platform. Our approach is to build a robus platform to connect professionals of different fields to worldwide clients & promote talent in tech industry.</p>
                        <p className='text- mt-2'>Our mission is to empower businesses and individuals through technology. We connect top tech staff with innovative companies, provide expert consulting services, and foster digital skills development. We strive for business growth, innovation, and societal progress. We are dedicated to delivering exceptional results and shaping the future of tech. Empowering a brighter digital tomorrow, one connection at a time.</p>
                    </div>
                </div>
                <div className='absolute right-20 md:top-10 top-40'>
                    <img src={require('../assets/images/dotsimage.png')} alt="" className='w-24 h-24' />
                </div>
            </div>

            {/* <div className='relative flex flex-col justify-center items-center w-full '>
                <div className='flex justify-center items-center'>
                    <div className='right-[-250px] absolute bg-gradient-to-r from-black to-logo rounded-3xl md:top-40 top-20 md:w-[480px] w-[280px] md:h-[480px] h-[280px] rotate-45'>
                        <div className='relative'>
                            <img src={require('../assets/images/2-removebg-preview.png')} className='absolute right-40 top-40 -rotate-45' alt="" />
                        </div>
                    </div>
                    <div className='flex flex-col justify-center md:mr-40 md:mt-60 mt-80 md:w-[560px] px-6'>
                        <h2 className='font-bold'>Speed</h2>
                        <h2 className='md:text-2xl text-xl font-bold text-logo py-2'>Double Your Speed To Lead</h2>
                        <p className='text-sm'>Double speed refers to a playback speed or operational rate that is twice as fast as the normal speed. It can apply to video or audio content, where doubling the speed allows for faster consumption of media, or to mechanical devices, where increasing speed enhances productivity but may require greater control or precision.</p>
                    </div>
                </div>

                <div className='relative flex flex-col justify-center items-center w-full '>
                    <div className='flex justify-center items-center'>
                        <div className='left-[-250px] absolute bg-gradient-to-r from-black to-logo rounded-3xl z-[1000] md:top-40 top-10 md:w-[480px] w-[280px] md:h-[480px] h-[280px] rotate-45'>
                            <div className='relative'>
                                <img src={require('../assets/images/1-removebg-preview.png')} className='absolute left-40 -top-20 -rotate-45' alt="" />
                            </div>
                        </div>
                        <div className='flex flex-col justify-center md:ml-60 md:mt-72 mt-80 md:w-[560px] px-6'>
                            <h2 className='font-bold'>Speed</h2>
                            <h2 className='md:text-2xl text-xl font-bold text-logo py-2'>Double Your Speed To Lead</h2>
                            <p className='text-sm'>Double speed refers to a playback speed or operational rate that is twice as fast as the normal speed. It can apply to video or audio content, where doubling the speed allows for faster consumption of media, or to mechanical devices, where increasing speed enhances productivity but may require greater control or precision.</p>
                        </div>
                    </div>
                </div>

            </div> */}


        </>
    )
}

export default Cards
